export const locale = {
    lang: 'en',
    data: {
        STUDIO_PROJECTS_NEW_PARENT_CREATE: 'Add Project',
        STUDIO_PROJECTS_NEW_PARENT_GENERAL: 'General',
        STUDIO_PROJECTS_NEW_PARENT_PROJECT_STRUCTURE: 'Project structure',
        STUDIO_PROJECTS_NEW_PARENT_MEMBERS: 'Members',
    }
};
